import React from "react";
import ReactTable from "react-table";
import Pagination from "react-js-pagination";
import {Grid, Row, Col} from "react-bootstrap";
import Select from "react-select";

const pageOptions = [
    {value: '5', label: '5'},
    {value: '10', label: '10'},
    {value: '20', label: '20'},
    {value: '50', label: '50'},
    {value: '100', label: '100'}
];

class ReactTableV6ServerSide extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            pages: null,
            loading: false,
            sorted: [],
            filtered: [],
            columns: [],
            pageSize: null,
            filter: "",

            activePage: null,
            totalItems: null

        }

        this.handleChildPageSizeChange = this.handleChildPageSizeChange.bind(this);
        this.handleChildSortChange = this.handleChildSortChange.bind(this);
        this.handleChildPageChange = this.handleChildPageChange.bind(this);
        this.handleChildUpdate = this.handleChildUpdate.bind(this);
    }

    handleChildUpdate() {
        this.props.parentHandlerRequestUpdate();
    }

    handleChildPageChange(pageNumber) {
        this.props.parentHandlerPageChange(pageNumber);
    }

    handleChildSortChange(newSort) {
        this.props.parentHandlerSortChange(newSort);
    }

    handleChildPageSizeChange(value) {
        this.props.parentHandlerPageSizeChange(value);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.columns !== prevProps.columns) {
            this.setState({columns: this.props.columns});
            //console.log("1.columns")
        }

        if (this.props.data !== prevProps.data) {
            this.setState({data: this.props.data});
            //console.log("2.data")
        }

        if (this.props.loading !== prevProps.loading) {
            this.setState({loading: this.props.loading});
            //console.log("3.loading")
        }

        if (this.props.sorted !== prevProps.sorted) {
            this.setState({sorted: this.props.sorted});
            this.handleChildUpdate();
            //console.log("4.sorted****")
        }

        if (this.props.pageSize !== prevProps.pageSize) {
            this.setState({pageSize: this.props.pageSize});
            this.handleChildUpdate();
            //console.log("5.pageSize*****")
        }

        if (this.props.pages !== prevProps.pages) {
            this.setState({pages: this.props.pages});
            //console.log("6.pages")
        }

        if (this.props.activePage !== prevProps.activePage) {
            this.setState({activePage: this.props.activePage});
            //this.handleChildUpdate();
            //console.log("7.activePage")
        }

        if (this.props.totalItems !== prevProps.totalItems) {
            this.setState({totalItems: this.props.totalItems});
            //console.log("8.totalItems")
        }

        if (this.props.filter !== prevProps.filter) {
            this.setState({filter: this.props.filter});
            this.handleChildUpdate();
            //console.log("9.filter*****")
        }

        if (this.props.filtered !== prevProps.filtered) {
            this.setState({filtered: this.props.filtered});
            this.handleChildUpdate();
            //console.log("10.filtered****")
        }

    }

    componentDidMount() {

        this.setState({
                columns: this.props.columns,
                data: this.props.data,
                loading: this.props.loading,
                sorted: this.props.sorted,
                pageSize: this.props.pageSize,
                pages: this.props.pages,
                activePage: this.props.activePage,
                totalItems: this.props.totalItems
            }
        );

    }

    render() {
        return (
            <div>
                <ReactTable
                    manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                    className="-striped -highlight"
                    showPagination={false}

                    columns={this.state.columns}
                    data={this.state.data}
                    pages={this.state.pages} // Display the total number of pages
                    loading={this.state.loading} // Display the loading overlay when we need it
                    sorted={this.state.sorted}
                    pageSize={this.state.pageSize}

                    onSortedChange={(newSort, column) => {
                        this.handleChildSortChange(newSort)
                    }}

                    // onFilteredChange={filtered => {
                    //     this.setState({filtered});
                    // }}

                />
                <legend style={{marginBottom: "0px"}}/>
                <Grid fluid>
                    <Row>
                        <Col md={5}>
                            <Pagination
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.pageSize}
                                totalItemsCount={this.state.totalItems === null ? 0 : this.state.totalItems}
                                pageRangeDisplayed={3}
                                onChange={this.handleChildPageChange}
                            />
                        </Col>
                        <Col md={2}>
                            <div className="center">
                                <ul className="pagination">
                                    <Select
                                        name="pageSelect"
                                        multi={false}
                                        options={pageOptions}
                                        clearable={false}
                                        searchable={false}
                                        defaultValue={pageOptions[0]}
                                        value={this.state.pageSize}
                                        components={{ClearIndicator: null}}
                                        onChange={(value) => (this.handleChildPageSizeChange(value))}
                                    />
                                </ul>
                            </div>
                        </Col>
                        <Col md={5}>
                            <div className="pull-right">
                                <ul className="pagination">
                                    {"Total Records: " + this.state.totalItems + " / Total Pages: " + this.state.pages}
                                </ul>
                            </div>
                        </Col>
                    </Row>

                </Grid>
            </div>
        );

    }

}

export default ReactTableV6ServerSide;
